import { Skeleton, Stack } from '@mui/material';

const BasicInformationSkeletom = () => {
    return (
        <>
            <div className="pt-20 centerClass" style={{ width: '98%' }}>
                <Stack spacing={1}>
                    <Skeleton
                        variant="rectangular"
                        height={'1.5vh'}
                        width={'10vh'}
                    />
                    <Skeleton variant="rounded" height={'82px'} />
                    <Skeleton variant="rounded" height={'50px'} />
                    <Skeleton variant="rounded" height={'50px'} />
                    <Skeleton variant="rounded" height={'50px'} />
                </Stack>
            </div>
        </>
    );
};

export default BasicInformationSkeletom;
